import { memberId } from './memberId';

export const isMemberLoggedIn = (): boolean => !!memberId;
